module.exports = __webpack_public_path__ + "img/NO937893833.bca18f78.png";